function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedExtraBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27 1v3h3v2h-3v3h-2V6h-3V4h3V1h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H10a5 5 0 00-5 5v8a4.992 4.992 0 00-2 4v9h2v-4h22v4h2v-9a4.993 4.993 0 00-2-4v-6h-2v5.1a5.022 5.022 0 00-1-.1c0-1.541-.464-2.735-1.021-3.56a4.446 4.446 0 00-.87-.968 2.642 2.642 0 00-.455-.301A1.46 1.46 0 0021 11H11c-.341 0-.61.153-.737.234a2.662 2.662 0 00-.455.375 5.13 5.13 0 00-.838 1.166c-.43.795-.8 1.873-.925 3.225H8c-.342 0-.677.034-1 .1V9a3 3 0 013-3h10V4zm2 12c0-1.126-.336-1.932-.679-2.44a2.468 2.468 0 00-.504-.56h-9.572l-.016.016a3.17 3.17 0 00-.5.71c-.281.521-.557 1.277-.673 2.274H22zM8 18a3 3 0 00-3 3v3h22v-3a3 3 0 00-3-3H8z",
    fill: props.color
  }));
}

export default SvgIconBedExtraBedFilled;